import React, { useState, useEffect } from "react";

const TypingText = ({ texts }) => {
  const typingSpeed = 20;   // ms per character
  const deletingSpeed = 80;  // ms per character when deleting
  const pauseTime = 2000;    // pause after typing a phrase

  const [text, setText] = useState("");
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (!texts || texts.length === 0) return;

    const currentPhrase = texts[phraseIndex];
    let timeout;

    if (!isDeleting) {
      if (charIndex < currentPhrase.length) {
        timeout = setTimeout(() => setCharIndex(charIndex + 1), typingSpeed);
      } else {
        timeout = setTimeout(() => setIsDeleting(true), pauseTime);
      }
    } else {
      if (charIndex > 0) {
        timeout = setTimeout(() => setCharIndex(charIndex - 1), deletingSpeed);
      } else {
        setIsDeleting(false);
        setPhraseIndex((phraseIndex + 1) % texts.length);
      }
    }

    setText(currentPhrase.slice(0, charIndex));

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, phraseIndex, texts]);

  return (
    <h1 style={{ fontFamily: "math", overflow: "hidden" }}>
      {text}
      <span
        style={{
          display: "inline-block",
          width: "0.1em",
          backgroundColor: "black",
          marginLeft: "2px",
          animation: "blink 1s steps(1) infinite",
        }}
      ></span>

      <style>{`
        @keyframes blink {
          50% { opacity: 0; }
        }
      `}</style>
    </h1>
  );
};

export default TypingText;
